import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/member/orderList/:orderStatus",
  name: "orderList",
  component: function component() {
    return import("@/views/order/member/orderList.vue");
  },
  meta: {
    title: "我的订单",
    foot: true
  }
}, {
  path: "/member/orderDetail/:orderId",
  name: "orderDetail",
  component: function component() {
    return import("@/views/order/member/orderDetail.vue");
  },
  meta: {
    title: "订单详情",
    foot: true
  }
}, {
  path: "/member/orderVerification/:orderId",
  name: "orderVerification",
  component: function component() {
    return import("@/views/order/member/orderVerification.vue");
  },
  meta: {
    title: "核销订单",
    foot: true
  }
}, {
  path: "/store/cashierOrderList",
  name: "cashierOrderList",
  component: function component() {
    return import("@/views/order/store/cashierOrderList.vue");
  },
  meta: {
    title: "收银台订单",
    foot: true
  }
}, {
  path: "/store/cashierOrderDetail/:orderId",
  name: "cashierOrderDetail",
  component: function component() {
    return import("@/views/order/store/cashierOrderDetail.vue");
  },
  meta: {
    title: "订单详情",
    foot: true
  }
}, {
  path: "/store/storeOrderList",
  name: "storeOrderList",
  component: function component() {
    return import("@/views/order/store/storeOrderList.vue");
  },
  meta: {
    title: "店铺订单",
    foot: true
  }
}, {
  path: "/store/storeRefundList",
  name: "storeRefundList",
  component: function component() {
    return import("@/views/order/store/storeRefundList.vue");
  },
  meta: {
    title: "售后订单",
    foot: true
  }
}, {
  path: "/store/storeRefundDetail/:refundId",
  name: "storeRefundDetail",
  component: function component() {
    return import("@/views/order/store/storeRefundDetail.vue");
  },
  meta: {
    title: "售后订单详情",
    foot: true
  }
}, {
  path: "/store/storeOrderDetail/:orderId",
  name: "storeOrderDetail",
  component: function component() {
    return import("@/views/order/store/storeOrderDetail.vue");
  },
  meta: {
    title: "订单详情",
    foot: true
  }
}];